// eslint-disable-next-line no-unused-vars,no-undef
const ShowMoreComponent = new ShowMore();
